export enum SemanticTypes {
    'AllOf',
    'AnyOf',
}
